'use client';
import { useState, useEffect, useCallback } from 'react';
import { extractDataLayerEventName } from './data-layer-event-name';
export function useDataLayerEvents(maxEvents = 50) {
    const [events, setEvents] = useState([]);
    const [isCapturing, setIsCapturing] = useState(true);
    useEffect(() => {
        if (!isCapturing)
            return;
        // Initialize dataLayer if it doesn't exist
        window.dataLayer = window.dataLayer || [];
        // Capture existing events
        const existingEvents = window.dataLayer.map((data, index) => ({
            id: `existing-${index}-${Date.now()}`,
            timestamp: new Date(),
            data: data,
            eventName: extractDataLayerEventName(data),
        }));
        if (existingEvents.length > 0) {
            setEvents(existingEvents.slice(-maxEvents));
        }
        // Store original push method
        const originalPush = window.dataLayer.push.bind(window.dataLayer);
        // Override push to capture new events
        window.dataLayer.push = function (...args) {
            // Capture each pushed item
            for (const data of args) {
                const newEvent = {
                    id: `event-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
                    timestamp: new Date(),
                    data: data,
                    eventName: extractDataLayerEventName(data),
                };
                setEvents(prev => [...prev.slice(-(maxEvents - 1)), newEvent]);
            }
            // Call original push
            return originalPush(...args);
        };
        // Cleanup: restore original push
        return () => {
            if (window.dataLayer) {
                window.dataLayer.push = originalPush;
            }
        };
    }, [isCapturing, maxEvents]);
    const clearEvents = useCallback(() => {
        setEvents([]);
    }, []);
    const toggleCapturing = useCallback(() => {
        setIsCapturing(prev => !prev);
    }, []);
    return { events, isCapturing, toggleCapturing, clearEvents };
}
